/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
// material
import { Control, TextField } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './timeframe_styles';



/* ========== ~~~~~~~~~~ COMMUNITY TOP ARTICLES : TIMEFRAME ~~~~~~~~~~ ========== */
const Timeframe = props => {
    const { topArticlesDaysTimeFrame, onChange } = props

    const selectedTimeframe = () => topArticlesDaysTimeFrame === 0 ? 'alltime' : 'custom'

    const handleSelectTimeFrame = value => {
        const timeFrameDays = value === 'alltime' ? 0 : (topArticlesDaysTimeFrame > 0 ? topArticlesDaysTimeFrame : 5);
        onChange(timeFrameDays)
    }

    const handleChangeCustomTimeFrameDays = value => {
        const numberValidTest = /^[0-9]{0,3}$/;
        if(!numberValidTest.test(value)) return;
        onChange(value)
    }

    return (
        <div className={`timeframe ${props.classes.timeframe} section`}>
            <div className={`sectioncontent`}>
                <Control 
                    text={'All time'} 
                    value={'alltime'}
                    handleSelect={handleSelectTimeFrame} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={selectedTimeframe() === 'alltime'}  
                />
                <Control 
                    text={'Custom time'} 
                    value={'custom'} 
                    handleSelect={handleSelectTimeFrame} 
                    variant={'secondary'} 
                    addCheckWhenSelected={true}
                    selected={selectedTimeframe() === 'custom'}  
                />
                { selectedTimeframe() === 'custom' &&
                    <div className={'daysfield'}>
                        <span>Last</span>
                        <TextField 
                            name={'customTime'}
                            type={'text'}
                            required={true}
                            valid={!!topArticlesDaysTimeFrame}
                            value={topArticlesDaysTimeFrame}
                            handleChange={e => handleChangeCustomTimeFrameDays(e.target.value)} 
                        />
                        <span>day(s)</span>
                    </div>
                }
            </div>
        </div>
    )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Timeframe);